/* eslint-disable no-empty */
import { LOCAL_STORAGE_KEYS } from '@hotjar/feedback/constant-types/LocalStorageKeys';
import type { Survey } from '../../Surveys/Survey/Survey';

interface StoreWizardData {
  data: Survey;
  section: string;
}

function getStorageKey(siteId: number) {
  return [LOCAL_STORAGE_KEYS.WIZARD_SURVEYS, siteId].join('_');
}

export function saveWizardState(model: unknown, siteId: number, section: string): void {
  const data = JSON.stringify({ data: model, section });
  try {
    sessionStorage.setItem(getStorageKey(siteId), data);
  } catch (err) {}
}

export function loadWizardState(siteId: number): StoreWizardData | undefined {
  try {
    const data = sessionStorage.getItem(getStorageKey(siteId));

    return data === null ? undefined : (JSON.parse(data) as StoreWizardData);
  } catch (err) {}
}

export function clearWizardState(siteId: number): void {
  try {
    sessionStorage.removeItem(getStorageKey(siteId));
  } catch (err) {}
}
